import type { UseFormReturn } from "react-hook-form";
import type { BusinessSettingsFormData } from "../type/business-settings";

export interface ValidationIssue {
  /** Field the owner has to fix, as shown on the page. */
  field: string;
  message: string;
}

interface FieldLabels {
  name: string;
  email: string;
  phone: string;
}

/**
 * Fields that failed the save check, in page order: the name, then each email
 * and phone row, numbered as on screen. Reads `getFieldState` rather than
 * `formState.errors`, whose proxy React Compiler can freeze inside callbacks.
 */
export function listValidationIssues(
  form: UseFormReturn<BusinessSettingsFormData>,
  labels: FieldLabels
): ValidationIssue[] {
  const issues: ValidationIssue[] = [];
  const add = (field: string, message: string | undefined) => {
    if (message) issues.push({ field, message });
  };

  add(labels.name, form.getFieldState("basicInfo.name").error?.message);
  form.getValues("contactInfo.emails").forEach((_, index) => {
    add(
      `${labels.email} ${index + 1}`,
      form.getFieldState(`contactInfo.emails.${index}.value`).error?.message
    );
  });
  form.getValues("contactInfo.phones").forEach((_, index) => {
    add(
      `${labels.phone} ${index + 1}`,
      form.getFieldState(`contactInfo.phones.${index}.value`).error?.message
    );
  });

  return issues;
}
